import {
  GlobalPersonDrawerCompanyLogo,
  GlobalPersonDrawerRole,
} from 'app/components/Drawers/GlobalPerson/styled';
import { PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';
import styled from 'styled-components';

export const CollectiveDirectoryPersonDrawerCTAWrapper = styled.div`
  display: flex;
  border-radius: 8px 8px 0px 0px;
`;

export const CollectiveDirectoryPersonDrawerCTAButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const CollectiveDirectoryPersonDrawerCTAButton = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  padding: 8px;
  width: 180px;

  border-radius: 100px;
  border: 2px solid var(--color-primary);

  transition: background 200ms ease;

  &:hover {
    background: var(--color-data-people-background-hover);
    border: 2px solid transparent;
  }

  &:disabled {
    & > span {
      color: rgba(23, 28, 51, 0.3);
    }
    & > svg {
      fill: rgba(23, 28, 51, 0.3);
      & > path {
        fill: rgba(23, 28, 51, 0.3);
      }
    }

    cursor: not-allowed;

    &:hover {
      background: transparent;
      border: 2px solid rgba(23, 28, 51, 0.3);
    }

    border: 2px solid rgba(23, 28, 51, 0.3);
  }
`;

export const CollectiveDirectoryPersonDrawerCTAButtonText = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);
`;
